<ng-container *ngIf="{
    period: periodSelection$ | async,
    aggregatedData: aggregatedData$ | async,
    requestData: requestData$ | async,
    isPending: requestIsPending$ | async
  } as resolver">

  <app-button-toggle-select
    *ngIf="resolver.period"
    id="period-toggle"
    [value]="resolver.period"
    [options]="[
      { value: 'month', label: labels.month },
      { value: 'year', label: labels.year }
    ]"
    (valueChange)="onPeriodChange($event)">
  </app-button-toggle-select>

  <calendar-picker
    *ngIf="resolver.period"
    id="calendar-picker"
    class="w-full"
    [startView]="resolver.period === 'month' ? 'year' : 'multi-year'"
    [disabled]="resolver.isPending || false"
    [mode]="resolver.period"
    (dateSelected)="onDateSelected($event)">
  </calendar-picker>

  <lib-block-title
    id="evcharge-energy-title"
    [title]="labels.title">
  </lib-block-title>

  <div id="space-0"></div>

  <div id="summary-cards">
    <ng-container *ngIf="resolver.isPending; else summaryCards">
      <ng-container *ngTemplateOutlet="noDataSkeleton"></ng-container>
    </ng-container>

    <ng-template #summaryCards>
      <ng-container *ngIf="resolver.aggregatedData && resolver.aggregatedData?.hasData && !resolver.isPending">
        <app-key-value-block
          class="w-full fx-center"
          [key]="labels.totalEnergy"
          [value]="(resolver.aggregatedData?.totalEnergy || 0).toFixed(2) + ' kWh'"
          [bgColor]="'bg-yellow-100'">
        </app-key-value-block>
        <app-key-value-block
          class="w-full fx-center"
          [key]="labels.totalSessions"
          [value]="(resolver.aggregatedData?.totalSessions || 0).toString()"
          [bgColor]="'bg-blue-100'">
        </app-key-value-block>
        <app-key-value-block
          class="w-full fx-center"
          [key]="labels.avgSessionEnergy"
          [value]="(resolver.aggregatedData?.avgSessionEnergy || 0).toFixed(2) + ' kWh'"
          [bgColor]="'bg-green-100'">
        </app-key-value-block>
      </ng-container>
    </ng-template>
  </div>

  <div
    id="energy-chart"
    class="energy-chart fx-col fx-gap-3">
    <ng-container *ngIf="resolver.isPending">
      <ion-skeleton-text
        class="h-full w-full min-h-100"
        animated="true">
      </ion-skeleton-text>
    </ng-container>

    <ng-container *ngIf="!resolver.isPending && (!resolver.aggregatedData || !resolver.aggregatedData?.hasData)">
      <div class="min-h-100 no-data-message fx-col fx-center fx-gap-3">
        <mat-icon class="s-20" svgIcon="no_data"></mat-icon>
        <span class="text-grey-400 tw-font-normal tw-text-base">
          {{ labels.noDataForTheSelectedPeriod }}
        </span>
      </div>
    </ng-container>

    <ng-container *ngIf="!resolver.isPending && resolver.aggregatedData && resolver.aggregatedData?.hasData && (chartOptions$ | async) as chartOptions">
      <div
        class="block-bg-contrast"
        echarts
        [options]="chartOptions">
      </div>
    </ng-container>
  </div>

  <div
    id="energy-chart-reduced"
    class="fx-gap-3 min-h-100">
    <ng-container *ngIf="resolver.isPending">
      <ion-skeleton-text
        class="h-full w-full min-h-100"
        animated="true">
      </ion-skeleton-text>
    </ng-container>

    <ng-container *ngIf="!resolver.isPending && (!resolver.aggregatedData || !resolver.aggregatedData?.hasData)">
      <div class="min-h-100 no-data-message fx-col fx-center fx-gap-3">
        <mat-icon class="s-20" svgIcon="no_data"></mat-icon>
        <span class="text-grey-400 tw-font-normal tw-text-base">
          {{ labels.noDataForTheSelectedPeriod }}
        </span>
      </div>
    </ng-container>

    <ng-container *ngIf="!resolver.isPending && resolver.aggregatedData && resolver.aggregatedData?.hasData && (reducedChartOptions$ | async) as reducedCharts">
      <div
        *ngFor="let chartOpt of reducedCharts"
        class="block-bg-contrast"
        echarts
        [options]="chartOpt">
      </div>
    </ng-container>
  </div>

  <ng-template #noDataSkeleton>
    <ion-skeleton-text
      class="w-full h-16"
      animated="true">
    </ion-skeleton-text>
    <ion-skeleton-text
      class="w-full h-16"
      animated="true">
    </ion-skeleton-text>
    <ion-skeleton-text
      class="w-full h-16"
      animated="true">
    </ion-skeleton-text>
  </ng-template>
</ng-container>
